import { BROWSER as I } from "esm-env";
function n(a, t, e, i) {
  if (e === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? a !== t || !i : !t.has(a)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e === "m" ? i : e === "a" ? i.call(a) : i ? i.value : t.get(a);
}
function h(a, t, e, i, s) {
  if (i === "m") throw new TypeError("Private method is not writable");
  if (i === "a" && !s) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? a !== t || !s : !t.has(a)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return i === "a" ? s.call(a, e) : s ? s.value = e : t.set(a, e), e;
}
const g = (a, t, e) => {
  const i = document.createElement(a), [s, o] = Array.isArray(t) ? [void 0, t] : [t, e];
  return s && Object.assign(i, s), o == null || o.forEach((r) => i.appendChild(r)), i;
}, ft = (a, t) => {
  var e;
  return t === "left" ? a.offsetLeft : (((e = a.offsetParent instanceof HTMLElement ? a.offsetParent : null) == null ? void 0 : e.offsetWidth) ?? 0) - a.offsetWidth - a.offsetLeft;
};
function dt(a, t, { reverse: e = !1 } = {}) {
  const i = a.length;
  for (let s = e ? i - 1 : 0; e ? s >= 0 : s < i; e ? s-- : s++)
    t(a[s], s);
}
function kt(a, t) {
  const e = t.formatToParts(a), i = [], s = [], o = [], r = [], l = {}, f = (c) => (l[c] || (l[c] = 0), `${c}:${l[c]++}`);
  let E = "", tt = !1, et = !1;
  for (const c of e) {
    E += c.value;
    const d = c.type === "minusSign" || c.type === "plusSign" ? "sign" : c.type;
    d === "integer" ? (tt = !0, s.push(...c.value.split("").map((G) => ({ type: d, value: parseInt(G) })))) : d === "group" ? s.push({ type: d, value: c.value }) : d === "decimal" ? (et = !0, o.push({ type: d, value: c.value, key: f(d) })) : d === "fraction" ? o.push(...c.value.split("").map((G) => ({ type: d, value: parseInt(G), key: f(d) }))) : (tt || et ? r : i).push({
      type: d,
      value: c.value,
      key: f(d)
    });
  }
  const it = [];
  for (let c = s.length - 1; c >= 0; c--)
    it.unshift({ ...s[c], key: f(s[c].type) });
  return {
    pre: i,
    integer: it,
    fraction: o,
    post: r,
    formatted: E,
    value: typeof a == "string" ? parseFloat(a) : a
  };
}
const pt = I ? HTMLElement : class {
}, ut = String.raw, mt = I && typeof CSS < "u" && CSS.supports("line-height", "mod(1,1)"), K = I ? matchMedia("(prefers-reduced-motion: reduce)") : null, X = "--_number-flow-d-opacity", J = "--_number-flow-d-width", z = "--_number-flow-dx", Q = "--_number-flow-d", gt = (() => {
  try {
    return CSS.registerProperty({
      name: X,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: z,
      syntax: "<length>",
      inherits: !0,
      initialValue: "0px"
    }), CSS.registerProperty({
      name: J,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: Q,
      syntax: "<number>",
      inherits: !0,
      initialValue: "0"
    }), !0;
  } catch {
    return !1;
  }
})(), ot = "var(--number-flow-char-height, 1em)", m = "var(--number-flow-mask-height, 0.25em)", N = `calc(${m} / 2)`, Y = "var(--number-flow-mask-width, 0.5em)", y = `calc(${Y} / var(--scale-x))`, P = "#000 0, transparent 71%", wt = "span", $t = ({ willChange: a }) => ({
  fontKerning: "none",
  display: "inline-block",
  lineHeight: ot,
  padding: `${m} 0`,
  willChange: a ? "transform" : void 0
}), st = ut`:host{display:inline-flex;align-items:baseline;direction:ltr;white-space:nowrap;position:relative;line-height:${ot} !important;isolation:isolate;}::slotted(${wt}){position:absolute;left:0;top:0;color:transparent !important;z-index:-5;}:host > .number,:host > .section{pointer-events:none;user-select:none;}.number,.number__inner{display:inline-flex;align-items:baseline;transform-origin:left top;}:host([data-will-change]) .number,:host([data-will-change]) .number__inner{will-change:transform;}.number{--scale-x:calc(1 + var(${J}) / var(--width));transform:translateX(var(${z})) scaleX(var(--scale-x));margin:0 calc(-1 * ${Y});position:relative;z-index:-1;overflow:clip;-webkit-mask-image:linear-gradient( to right,transparent 0,#000 ${y},#000 calc(100% - ${y}),transparent ),linear-gradient( to bottom,transparent 0,#000 ${m},#000 calc(100% - ${m}),transparent 100% ),radial-gradient(at bottom right,${P}),radial-gradient(at bottom left,${P}),radial-gradient(at top left,${P}),radial-gradient(at top right,${P});-webkit-mask-size:100% calc(100% - ${m} * 2),calc(100% - ${y} * 2) 100%,${y} ${m},${y} ${m},${y} ${m},${y} ${m};-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat;}.number__inner{padding:0 ${Y};transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(${z})));}.section{display:inline-flex;align-items:baseline;padding-bottom:${N};padding-top:${N};position:relative;isolation:isolate;}.section::after{content:'\200b';display:block;padding:${N} 0;}:host([data-will-change]) .section{will-change:transform;}.section--justify-left{transform-origin:center left;}.section--justify-right{transform-origin:center right;}.section__exiting{position:absolute !important;z-index:-1;}.digit{display:block;position:relative;--c:var(--current) + var(${Q});}:host([data-will-change]) .digit,:host([data-will-change]) .digit__num{will-change:transform;}.digit__num{display:block;padding:${N} 0;--offset-raw:mod(10 + var(--n) - mod(var(--c),10),10);--offset:calc(var(--offset-raw) - 10 * round(down,var(--offset-raw) / 5,1));--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y));}.digit__num:not(.is-current){position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y));}.digit:not(.is-spinning) .digit__num:not(.is-current){display:none;}.symbol{display:inline-flex;align-items:baseline;position:relative;isolation:isolate;padding:${N} 0;}:host([data-will-change]) .symbol{will-change:transform;}.symbol__value{display:block;white-space:pre;}.symbol__exiting{position:absolute;z-index:-1;}.section--justify-left .symbol__exiting{left:0;}.section--justify-right .symbol__exiting{right:0;}.animate-presence{opacity:calc(1 + var(${X}));}`;
var R, L, _, v, b, S, C, $, T, x, k, A, D, F, W, O, M, U, u, B, Z, w, H, V;
const yt = mt && gt;
var p;
(function(a) {
  a[a.UP = 1] = "UP", a[a.DOWN = -1] = "DOWN", a[a.NONE = 0] = "NONE";
})(p || (p = {}));
const rt = (a, t) => {
  if (t != null)
    return a > t ? p.UP : a < t ? p.DOWN : p.NONE;
}, _t = { duration: 450, easing: "ease-out" }, vt = {
  duration: 900,
  // Make sure to keep this minified:
  easing: "linear(0,.005,.019,.039,.066,.096,.129,.165,.202,.24,.278,.316,.354,.39,.426,.461,.494,.526,.557,.586,.614,.64,.665,.689,.711,.731,.751,.769,.786,.802,.817,.831,.844,.856,.867,.877,.887,.896,.904,.912,.919,.925,.931,.937,.942,.947,.951,.955,.959,.962,.965,.968,.971,.973,.976,.978,.98,.981,.983,.984,.986,.987,.988,.989,.99,.991,.992,.992,.993,.994,.994,.995,.995,.996,.996,.9963,.9967,.9969,.9972,.9975,.9977,.9979,.9981,.9982,.9984,.9985,.9987,.9988,.9989,1)"
};
let j;
class Et extends pt {
  constructor() {
    super(...arguments), this.transformTiming = vt, this.opacityTiming = _t, R.set(this, !0), this.manual = !1, this.respectMotionPreference = !0, L.set(this, !1), _.set(this, void 0), v.set(this, void 0), b.set(this, void 0), this.trend = !0, S.set(this, void 0), C.set(this, void 0), $.set(this, void 0);
  }
  static define() {
    I && customElements.define("number-flow", this);
  }
  getComputedTrend() {
    return n(this, S, "f");
  }
  set parts(t) {
    if (t == null)
      return;
    const { pre: e, integer: i, fraction: s, post: o, value: r } = t;
    if (n(this, L, "f")) {
      const l = n(this, C, "f");
      h(this, C, r, "f"), this.trend === !0 ? h(this, S, rt(r, l), "f") : this.trend === "increasing" ? h(this, S, p.UP, "f") : this.trend === "decreasing" ? h(this, S, p.DOWN, "f") : h(this, S, p.NONE, "f"), this.manual || this.willUpdate(), n(this, _, "f").update(e), n(this, v, "f").update({ integer: i, fraction: s }), n(this, b, "f").update(o), this.manual || this.didUpdate();
    } else {
      if (h(this, C, r, "f"), this.attachShadow({ mode: "open" }), typeof CSSStyleSheet < "u" && this.shadowRoot.adoptedStyleSheets)
        j || (j = new CSSStyleSheet(), j.replaceSync(st)), this.shadowRoot.adoptedStyleSheets = [j];
      else {
        const l = document.createElement("style");
        l.textContent = st, this.shadowRoot.appendChild(l);
      }
      this.shadowRoot.appendChild(g("slot")), h(this, _, new at(this, e, {
        inert: !0,
        ariaHidden: "true",
        justify: "right"
      }), "f"), this.shadowRoot.appendChild(n(this, _, "f").el), h(this, v, new bt(this, i, s, {
        inert: !0,
        ariaHidden: "true"
      }), "f"), this.shadowRoot.appendChild(n(this, v, "f").el), h(this, b, new at(this, o, {
        inert: !0,
        ariaHidden: "true",
        justify: "left"
      }), "f"), this.shadowRoot.appendChild(n(this, b, "f").el);
    }
    h(this, L, !0, "f");
  }
  willUpdate() {
    this.animated && (n(this, _, "f").willUpdate(), n(this, v, "f").willUpdate(), n(this, b, "f").willUpdate());
  }
  didUpdate() {
    if (!this.animated)
      return;
    n(this, $, "f") ? n(this, $, "f").abort() : this.dispatchEvent(new Event("animationsstart")), n(this, _, "f").didUpdate(), n(this, v, "f").didUpdate(), n(this, b, "f").didUpdate();
    const t = new AbortController();
    Promise.all(this.shadowRoot.getAnimations().map((e) => e.finished)).then(() => {
      t.signal.aborted || (this.dispatchEvent(new Event("animationsfinish")), h(this, $, void 0, "f"));
    }), h(this, $, t, "f");
  }
  get animated() {
    return yt && n(this, R, "f") && (!this.respectMotionPreference || !(K != null && K.matches));
  }
  set animated(t) {
    var e;
    this.animated !== t && (h(this, R, t, "f"), (e = this.shadowRoot) == null || e.getAnimations().forEach((i) => i.finish()));
  }
}
R = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
class bt {
  constructor(t, e, i, { className: s, ...o } = {}) {
    this.flow = t, T.set(this, void 0), x.set(this, void 0), k.set(this, void 0), A.set(this, void 0), D.set(this, void 0), h(this, x, new nt(t, e, {
      justify: "right"
    }), "f"), h(this, k, new nt(t, i, {
      justify: "left"
    }), "f"), h(this, T, g("span", {
      className: "number__inner"
    }, [n(this, x, "f").el, n(this, k, "f").el]), "f"), this.el = g("span", {
      ...o,
      className: `number ${s ?? ""}`
    }, [n(this, T, "f")]);
  }
  willUpdate() {
    h(this, A, this.el.offsetWidth, "f"), h(this, D, this.el.getBoundingClientRect().left, "f"), n(this, x, "f").willUpdate(), n(this, k, "f").willUpdate();
  }
  update({ integer: t, fraction: e }) {
    n(this, x, "f").update(t), n(this, k, "f").update(e);
  }
  didUpdate() {
    const t = this.el.getBoundingClientRect();
    n(this, x, "f").didUpdate(), n(this, k, "f").didUpdate();
    const e = n(this, D, "f") - t.left, i = this.el.offsetWidth, s = n(this, A, "f") - i;
    this.el.style.setProperty("--width", String(i)), this.el.animate({
      [z]: [`${e}px`, "0px"],
      [J]: [s, 0]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}
T = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
class lt {
  constructor(t, e, { justify: i, className: s, ...o }, r) {
    this.flow = t, this.children = /* @__PURE__ */ new Map(), this.onCharRemove = (f) => () => {
      this.children.delete(f);
    }, F.set(this, void 0), this.justify = i;
    const l = e.map((f) => this.addChar(f).el);
    this.el = g("span", {
      ...o,
      className: `section section--justify-${i} ${s ?? ""}`
    }, r ? r(l) : l);
  }
  addChar(t, { startDigitsAtZero: e = !1, ...i } = {}) {
    const s = t.type === "integer" || t.type === "fraction" ? new ct(this, t.type, e ? 0 : t.value, {
      ...i,
      onRemove: this.onCharRemove(t.key)
    }) : new St(this, t.type, t.value, {
      ...i,
      onRemove: this.onCharRemove(t.key)
    });
    return this.children.set(t.key, s), s;
  }
  unpop(t) {
    t.el.classList.remove("section__exiting"), t.el.style[this.justify] = "";
  }
  pop(t) {
    t.forEach((e) => {
      e.el.style[this.justify] = `${ft(e.el, this.justify)}px`;
    }), t.forEach((e) => {
      e.el.classList.add("section__exiting"), e.present = !1;
    });
  }
  addNewAndUpdateExisting(t) {
    const e = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = this.justify === "left", o = s ? "prepend" : "append";
    if (dt(t, (r) => {
      let l;
      this.children.has(r.key) ? (l = this.children.get(r.key), i.set(r, l), this.unpop(l), l.present = !0) : (l = this.addChar(r, { startDigitsAtZero: !0, animateIn: !0 }), e.set(r, l)), this.el[o](l.el);
    }, { reverse: s }), this.flow.animated) {
      const r = this.el.getBoundingClientRect();
      e.forEach((l) => {
        l.willUpdate(r);
      });
    }
    e.forEach((r, l) => {
      r.update(l.value);
    }), i.forEach((r, l) => {
      r.update(l.value);
    });
  }
  willUpdate() {
    const t = this.el.getBoundingClientRect();
    h(this, F, t[this.justify], "f"), this.children.forEach((e) => e.willUpdate(t));
  }
  didUpdate() {
    const t = this.el.getBoundingClientRect();
    this.children.forEach((s) => s.didUpdate(t));
    const e = t[this.justify], i = n(this, F, "f") - e;
    this.el.animate({
      transform: [`translateX(${i}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}
F = /* @__PURE__ */ new WeakMap();
class nt extends lt {
  update(t) {
    const e = /* @__PURE__ */ new Map();
    this.children.forEach((i, s) => {
      t.find((o) => o.key === s) || e.set(s, i), this.unpop(i);
    }), this.addNewAndUpdateExisting(t), e.forEach((i) => {
      i instanceof ct && i.update(0);
    }), this.pop(e);
  }
}
class at extends lt {
  update(t) {
    const e = /* @__PURE__ */ new Map();
    this.children.forEach((i, s) => {
      t.find((o) => o.key === s) || e.set(s, i);
    }), this.pop(e), this.addNewAndUpdateExisting(t);
  }
}
class q {
  constructor(t, e, { onRemove: i, animateIn: s = !1 } = {}) {
    this.flow = t, this.el = e, W.set(this, !0), O.set(this, void 0), M.set(this, () => {
      var o;
      this.el.remove(), (o = n(this, O, "f")) == null || o.call(this);
    }), this.el.classList.add("animate-presence"), this.flow.animated && s && this.el.animate({
      [X]: [-0.9999, 0]
    }, {
      ...this.flow.opacityTiming,
      composite: "accumulate"
    }), h(this, O, i, "f");
  }
  get present() {
    return n(this, W, "f");
  }
  set present(t) {
    if (n(this, W, "f") !== t) {
      if (h(this, W, t, "f"), !this.flow.animated) {
        t || n(this, M, "f").call(this);
        return;
      }
      this.el.style.setProperty("--_number-flow-d-opacity", t ? "0" : "-.999"), this.el.animate({
        [X]: t ? [-0.9999, 0] : [0.999, 0]
      }, {
        ...this.flow.opacityTiming,
        composite: "accumulate"
      }), t ? this.flow.removeEventListener("animationsfinish", n(this, M, "f")) : this.flow.addEventListener("animationsfinish", n(this, M, "f"), {
        once: !0
      });
    }
  }
}
W = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
class ht extends q {
  constructor(t, e, i, s) {
    super(t.flow, i, s), this.section = t, this.value = e, this.el = i;
  }
}
class ct extends ht {
  constructor(t, e, i, s) {
    const o = Array.from({ length: 10 }).map((l, f) => {
      const E = g("span", { className: `digit__num${f === i ? " is-current" : ""}` }, [document.createTextNode(String(f))]);
      return E.style.setProperty("--n", String(f)), E;
    }), r = g("span", {
      className: "digit"
    }, o);
    r.style.setProperty("--current", String(i)), super(t, i, r, s), U.set(this, void 0), u.set(this, void 0), B.set(this, void 0), Z.set(this, () => {
      this.el.classList.remove("is-spinning");
    }), h(this, U, o, "f");
  }
  get trend() {
    const t = this.flow.getComputedTrend();
    return t === p.NONE ? rt(this.value, n(this, u, "f")) : t;
  }
  willUpdate(t) {
    const e = this.el.getBoundingClientRect();
    h(this, u, this.value, "f");
    const i = e[this.section.justify] - t[this.section.justify], s = e.width / 2;
    h(this, B, this.section.justify === "left" ? i + s : i - s, "f");
  }
  update(t) {
    var e, i;
    (e = n(this, U, "f")[this.value]) == null || e.classList.remove("is-current"), this.el.style.setProperty("--current", String(t)), (i = n(this, U, "f")[t]) == null || i.classList.add("is-current"), this.value = t;
  }
  didUpdate(t) {
    const e = this.el.getBoundingClientRect(), i = e[this.section.justify] - t[this.section.justify], s = e.width / 2, o = this.section.justify === "left" ? i + s : i - s;
    if (this.el.animate({
      transform: [`translateX(${n(this, B, "f") - o}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    }), this.value === n(this, u, "f"))
      return;
    const r = this.trend;
    let l = this.value - n(this, u, "f");
    r === p.DOWN && this.value > n(this, u, "f") && (l = this.value - 10 - n(this, u, "f")), r === p.UP && this.value < n(this, u, "f") && (l = 10 - n(this, u, "f") + this.value), this.el.classList.add("is-spinning"), this.el.animate({
      [Q]: [-l, 0]
    }, {
      ...this.flow.spinTiming ?? this.flow.transformTiming,
      composite: "accumulate"
    }), this.flow.addEventListener("animationsfinish", n(this, Z, "f"), { once: !0 });
  }
}
U = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), Z = /* @__PURE__ */ new WeakMap();
class St extends ht {
  constructor(t, e, i, s) {
    const o = g("span", {
      className: "symbol__value",
      textContent: i
    });
    super(t, i, g("span", {
      className: "symbol"
    }, [o]), s), this.type = e, w.set(this, /* @__PURE__ */ new Map()), H.set(this, void 0), V.set(this, (r) => () => {
      n(this, w, "f").delete(r);
    }), n(this, w, "f").set(i, new q(this.flow, o, {
      onRemove: n(this, V, "f").call(this, i)
    }));
  }
  willUpdate(t) {
    if (this.type === "decimal")
      return;
    const e = this.el.getBoundingClientRect();
    h(this, H, e[this.section.justify] - t[this.section.justify], "f");
  }
  update(t) {
    if (this.value !== t) {
      const e = n(this, w, "f").get(this.value);
      if (e.present = !1, e.el.classList.add("symbol__exiting"), n(this, w, "f").has(t)) {
        const i = n(this, w, "f").get(t);
        i.present = !0, i.el.classList.remove("symbol__exiting");
      } else {
        const i = g("span", {
          className: "symbol__value",
          textContent: t
        });
        this.el.appendChild(i), n(this, w, "f").set(t, new q(this.flow, i, {
          animateIn: !0,
          onRemove: n(this, V, "f").call(this, t)
        }));
      }
    }
    this.value = t;
  }
  didUpdate(t) {
    if (this.type === "decimal")
      return;
    const i = this.el.getBoundingClientRect()[this.section.justify] - t[this.section.justify];
    this.el.animate({
      transform: [`translateX(${n(this, H, "f") - i}px)`, "none"]
    }, { ...this.flow.transformTiming, composite: "accumulate" });
  }
}
w = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap();
export {
  Et as NumberFlowLite,
  wt as SlottedTag,
  yt as canAnimate,
  _t as defaultOpacityTiming,
  vt as defaultTransformTiming,
  kt as partitionParts,
  K as prefersReducedMotion,
  $t as slottedStyles
};
